import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.css']
})
export class ConfirmationPopupComponent implements OnInit {

  @ViewChild('contentConfirmation') modal: ElementRef;
  @Output() onClickYes: EventEmitter<any> = new EventEmitter();
  @Output() deleteEvent= new EventEmitter();
  labelForPopup : string;
  leadInfo: any;
  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
  }

  showModal(popupLabel, updateInfo) {
    //
    this.leadInfo = updateInfo;
    this.labelForPopup = popupLabel;
    this.modalRef = this.modalService.open(this.modal, { windowClass: 'confirm-modal' });
  }

  clickedYes(event) {
    this.onClickYes.emit(this.leadInfo);
  }

  clickedNo(event) {
    let arr = [];
    arr.push(this.leadInfo.per_id[0]);
    this.leadInfo.per_id = [];
    this.leadInfo.per_id = arr;
    this.onClickYes.emit(this.leadInfo);
  }

  closeModal() {
    this.modalRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modal-popup/confirmation-popup/confirmation-popup.component.ts